import Vuex from 'vuex';
import Vue from 'vue';
import createPersistedState from "vuex-persistedstate";
import auth from './modules/auth';
import twofacode from './modules/twofacode';
import leads from './modules/leads';
import visitors from './modules/visitors';

// Load Vuex
Vue.use(Vuex);
// Create store
export default new Vuex.Store({
  modules: {
    auth,
    twofacode,
    leads,
    visitors
  },
  plugins: [createPersistedState()]
});


// WEBPACK FOOTER //
// ./src/store/index.js